exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".create-agent .org-agent-wrap {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex-end;\n  color: rgba(72, 72, 102, 0.92);\n}\n.create-agent .org-agent-wrap .divider-wrap {\n  height: 100%;\n  padding-bottom: 8px;\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.create-agent .org-agent-wrap .agent-wrap {\n  width: 100%;\n}\n.create-agent .page-body {\n  width: 100%;\n  margin: auto;\n}\n.create-agent .page-body > .body-content {\n  padding: 0 48px;\n}\n", ""]);

// exports
